import { render } from "./ChildrenGrowth.vue?vue&type=template&id=7bda13ca&scoped=true&ts=true"
import script from "./ChildrenGrowth.vue?vue&type=script&lang=ts"
export * from "./ChildrenGrowth.vue?vue&type=script&lang=ts"

import "./ChildrenGrowth.vue?vue&type=style&index=0&id=7bda13ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bda13ca"]])

export default __exports__